import gql from 'graphql-tag';

export const fields = `
    displayName
    variableName
    createdAt
    updatedAt
`;

export const relationsFields = `
`;

// default methods
export const paginationQuery = gql`
    query DigitaiPaginateChartVariables (
        $query: QueryStatement
        $constraint: QueryStatement
    ) {
        pagination: digitaiPaginateChartVariables (
            query: $query
            constraint: $constraint
        ) {
            total
            rows
            count
        }
    }
`;

export const getQuery = gql`
    query DigitaiGetChartVariables (
        $query: QueryStatement
        $constraint: QueryStatement
    ) {
        objects: digitaiGetChartVariables (
            query: $query
            constraint: $constraint
        ) {
            id
            #FIELDS
        }
    }
`;

export const findByIdQuery = gql`
    query DigitaiFindChartVariableById (
        $id: ID
        $constraint: QueryStatement
    ) {
        object: digitaiFindChartVariableById (
            id: $id
            constraint: $constraint
        ) {
            id
            #FIELDS
        }
    }
`;

export const findQuery = gql`
    query DigitaiFindChartVariable (
        $query: QueryStatement
        $constraint: QueryStatement
    ) {
        object: digitaiFindChartVariable (
            query: $query
            constraint: $constraint
        ) {
            id
            #FIELDS
        }
    }
`;

export const createMutation = gql`
    mutation DigitaiCreateChartVariable (
        $payload: DigitaiCreateChartVariableInput!
    ) {
        digitaiCreateChartVariable (
            payload: $payload
        ) {
            ${fields}
        }
    }
`;

export const insertMutation = gql`
    mutation DigitaiCreateChartVariables (
        $payload: [DigitaiCreateChartVariableInput]!
    ) {
        digitaiCreateChartVariables (
            payload: $payload
        )
    }
`;

export const updateByIdMutation = gql`
    mutation DigitaiUpdateChartVariableById (
        $payload: DigitaiUpdateChartVariableByIdInput!
        $constraint: QueryStatement
    ) {
        digitaiUpdateChartVariableById (
            payload: $payload
            constraint: $constraint
        ) {
            ${fields}
        }
    }
`;

export const updateMutation = gql`
    mutation DigitaiUpdateChartVariables (
        $payload: DigitaiUpdateChartVariablesInput!
        $query: QueryStatement
        $constraint: QueryStatement
    ) {
        digitaiUpdateChartVariables (
            payload: $payload
            query: $query
            constraint: $constraint
        ) {
            ${fields}
        }
    }
`;

export const deleteByIdMutation = gql`
    mutation DigitaiDeleteChartVariableById (
        $id: ID!
        $constraint: QueryStatement
    ) {
        digitaiDeleteChartVariableById (
            id: $id
            constraint: $constraint
        ) {
            ${fields}
        }
    }
`;

export const deleteMutation = gql`
    mutation DigitaiDeleteChartVariables (
        $query: QueryStatement
        $constraint: QueryStatement
    ) {
        digitaiDeleteChartVariables (
            query: $query
            constraint: $constraint
        ) {
            ${fields}
        }
    }
`;
